import { changeTimezone } from "@smartsuite/fields-logic/lib/utils/date";
import { addDays, isValid, parse, startOfDay } from "date-fns";

export const NOW_MARKER = "now";
const NOW_PLUS_PATTERN = /^now\+(\d+)$/;

export interface DateDefaultContext {
  timezone: string;
}

/**
 * The calendar day a default names, as browser-local midnight — the shape every date picker in the
 * form produces. `now`/`now+N` name a day in the respondent's timezone, so the current instant is
 * shifted into that timezone before the day is taken; taking it from UTC hands users west of GMT
 * yesterday and users east of it tomorrow. A fixed default already names a day, so it is parsed
 * locally and never shifts.
 */
export const resolveDefaultDate = (value: string, timezone: string): Date | null => {
  const today = (): Date => startOfDay(changeTimezone(new Date(), timezone));

  if (value === NOW_MARKER) return today();

  const plusMatch = NOW_PLUS_PATTERN.exec(value);
  if (plusMatch) return startOfDay(addDays(today(), Number(plusMatch[1])));

  const parsed = parse(value, "yyyy-MM-dd", new Date());

  return isValid(parsed) ? parsed : null;
};
